import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Table({ columns, data, loading, page, pages, total, onPage, rowStyle }) {
  return (
    <div className="glass glow-border rounded-2xl overflow-hidden">
      <div className="overflow-x-auto">
        <table className="table-dark">
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th key={i}>{col.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={columns.length} className="py-12 text-center" style={{ color: '#334155' }}>
                <div className="flex items-center justify-center gap-2">
                  <div className="w-4 h-4 rounded-full border-2 border-blue-500 border-t-transparent animate-spin" />
                  Loading...
                </div>
              </td></tr>
            ) : data.length === 0 ? (
              <tr><td colSpan={columns.length} className="py-12 text-center" style={{ color: '#334155' }}>No records found</td></tr>
            ) : data.map((row, i) => (
              <tr key={row.id || i} style={rowStyle ? rowStyle(row) : {}}>
                {columns.map((col, j) => (
                  <td key={j}>{col.render ? col.render(row) : row[col.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {(total != null || pages > 1) && (
        <div className="px-4 py-3 flex items-center justify-between" style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}>
          <span className="text-xs" style={{ color: '#334155' }}>{total ?? 0} records</span>
          {pages > 1 && (
            <div className="flex items-center gap-1">
              <button onClick={() => onPage(page - 1)} disabled={page <= 1}
                className="p-1.5 rounded-lg transition-colors disabled:opacity-30" style={{ color: '#64748b' }}
                onMouseEnter={e => e.target.style.color='#e2e8f0'} onMouseLeave={e => e.target.style.color='#64748b'}>
                <ChevronLeft size={15} />
              </button>
              <span className="text-xs px-2" style={{ color: '#64748b' }}>Page {page} of {pages}</span>
              <button onClick={() => onPage(page + 1)} disabled={page >= pages}
                className="p-1.5 rounded-lg transition-colors disabled:opacity-30" style={{ color: '#64748b' }}
                onMouseEnter={e => e.target.style.color='#e2e8f0'} onMouseLeave={e => e.target.style.color='#64748b'}>
                <ChevronRight size={15} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
